import React, { useState } from 'react';

// Simple chips input. Press Enter (or comma) to add, click × to remove.
// `suggestions` populates a datalist so users pick consistent values.
const TagsInput = ({ value = [], onChange, placeholder = 'Type and press Enter', suggestions = [], id = 'tags-input' }) => {
    const [text, setText] = useState('');

    const addTag = (raw) => {
        const tag = raw.trim();
        if (!tag) return;
        if (value.some(v => v.toLowerCase() === tag.toLowerCase())) {
            setText('');
            return;
        }
        onChange([...value, tag]);
        setText('');
    };

    const removeTag = (index) => {
        onChange(value.filter((_, i) => i !== index));
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            addTag(text);
        } else if (e.key === 'Backspace' && !text && value.length) {
            removeTag(value.length - 1);
        }
    };

    return (
        <div className="form-control d-flex flex-wrap align-items-center gap-2" style={{ minHeight: '44px' }}>
            {value.map((tag, index) => (
                <span key={tag} className="badge badge-light-success fs-7 d-inline-flex align-items-center">
                    {tag}
                    <button
                        type="button"
                        className="btn btn-sm btn-icon p-0 ms-2 h-auto w-auto"
                        onClick={() => removeTag(index)}
                        aria-label={`Remove ${tag}`}
                    >
                        <i className="bi bi-x fs-6"></i>
                    </button>
                </span>
            ))}
            <input
                type="text"
                className="border-0 flex-grow-1"
                style={{ outline: 'none', minWidth: '150px', background: 'transparent' }}
                value={text}
                list={suggestions.length ? `${id}-list` : undefined}
                onChange={e => setText(e.target.value)}
                onKeyDown={handleKeyDown}
                onBlur={() => addTag(text)}
                placeholder={value.length ? '' : placeholder}
            />
            {suggestions.length > 0 && (
                <datalist id={`${id}-list`}>
                    {suggestions.filter(s => !value.includes(s)).map(s => <option key={s} value={s} />)}
                </datalist>
            )}
        </div>
    );
};

export default TagsInput;
